import { render, staticRenderFns } from "./video-card-gallery.vue?vue&type=template&id=71dfbce8&scoped=true"
import script from "./video-card-gallery.vue?vue&type=script&lang=js"
export * from "./video-card-gallery.vue?vue&type=script&lang=js"
import style0 from "./video-card-gallery.vue?vue&type=style&index=0&id=71dfbce8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71dfbce8",
  null
  
)

export default component.exports